import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=6c8489c4&scoped=true&"
import script from "./CustomList.vue?vue&type=script&lang=ts&"
export * from "./CustomList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8489c4",
  null
  
)

export default component.exports